export default {
    pageTitle: 'Informes de datos',
    requestedBy: 'Solicitado por',
    date: 'Fecha',
    type: 'Tipo',
    equipmentReplicatedServicesReport: 'Servicios del equipo',
    equipmentReplicatedServicesReportHover: 'Último servicio completado de cada tipo de servicio del equipo',
    completed: 'Completado',
    failed: 'Fallido',
    scheduled: 'Programado',
    processing: 'Procesando',
    equipmentReplicatedServicesWithAttachmentsReport: 'Servicios del equipo con anexos',
    equipmentReplicatedServicesWithAttachmentsReportHover: 'Último servicio completado de cada tipo de servicio del equipo con anexos',
}